
<!-- 光伏系统比较 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <div class="compare-container">
        <div class="left-config">
          <div class="top-toolbar">
            <el-button type="text" class="button-clear__selection" @click="handleClearTableSelect">{{ $t('text.qxxz') }}</el-button>
          </div>
          <div class="table-container">
            <el-table
              v-if="showTable"
              ref="stationTableRef"
              v-loading="loading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.7)"
              :data="tableData"
              :height="tableHeight"
              :row-class-name="tableRowClassName"
              @selection-change="handleTableSelectChange"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column prop="orgname" :label="$t('text.gfxt')" />
              <el-table-column prop="capacity" align="right" :label="`${$t('text.zjrl')}(KWp)`" />
            </el-table>
          </div>
        </div>
        <div class="right-chart">
          <div class="chart-config">
            <div>
              <el-date-picker
                v-show="active === 'day'"
                v-model="selectTime"
                type="date"
                style="margin-top: 0;"
                :format="format"
                :clearable="false"
                @change="getChartData"
              />
              <el-date-picker
                v-show="active === 'month'"
                v-model="selectTime"
                type="month"
                style="margin-top: 0;"
                :format="format"
                :clearable="false"
                @change="getChartData"
              />
              <el-date-picker
                v-show="active === 'year'"
                v-model="selectTime"
                type="year"
                style="margin-top: 0;"
                :format="format"
                :clearable="false"
                @change="getChartData"
              />
            </div>
            <div>
              <el-button-group>
                <el-button
                  :type="active==='day'?'primary':''"
                  @click="activeChange('day','yyyy-MM-dd','hh:mm')"
                >{{ $t('text.t') }}</el-button>
                <el-button
                  :type="active==='month'?'primary':''"
                  @click="activeChange('month','yyyy-MM','dd')"
                >{{ $t('text.y') }}</el-button>
                <el-button
                  :type="active==='year'?'primary':''"
                  @click="activeChange('year','yyyy', 'MM')"
                >{{ $t('text.n') }}</el-button>
                <el-button
                  :type="active==='total'?'primary':''"
                  @click="activeChange('total',null, 'yyyy')"
                >{{ $t('text.zj') }}</el-button>
              </el-button-group>
            </div>
          </div>
          <div class="chart-container">
            <toggle-chart
              :data="chart.data"
              :columns="chart.columns"
              :setting="chart.setting"
              :loading="chartLoading || loading"
              :extend="chart.extend"
              :format="format"
              :unit="chart.unit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleChart from '@views/Charts/ToggleChart'
import { GetStringAndEnergyStorageStationsList } from '@apis/Universal'
import { StationsCompare } from '@apis/Statistics'
import { combineData } from '@utils'
export default {
  components: {
    ToggleChart
  },
  data () {
    return {
      loading: false, // 表格加载
      tableData: [], // 表格数据
      selected: [], // 选择的电站
      selectedColor: [], // 选择的电站颜色
      selectTime: this.$parseTime(new Date(), 'yyyy-MM-dd'), // 选择时间
      format: 'yyyy-MM-dd', // 时间格式化
      chartFormat: 'hh:mm',
      active: 'day', // 选择时间类型
      color: ['#889DCE', '#97CF85', '#E58067', '#F7D96C', '#006976'], // 颜色表
      chartLoading: false, // 图表加载
      queryChartDataTimer: null, // 定时器
      chart: { // 图表属性
        columns: ['time'],
        data: [],
        setting: { type: 'line', area: true },
        extend: {
          textStyle: {
            color: '#fff'
          },
          legend: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        unit: 'kW',
      },
      tableHeight: 0,
      showTable: false
    }
  },
  mounted () {
    this.setTableHeight().then(() => {
      this.getStationList()
    })
  },
  methods: {

    /** 设置表格高度 */
    setTableHeight () {
      return new Promise((resolv, reject) => {
        const leftConfig = document.getElementsByClassName('table-container')[0]
        this.tableHeight = leftConfig.clientHeight
        this.showTable = true
        resolv()
      })
    },
    /** 表格行样式 */
    tableRowClassName ({ row, _rowIndex }) {
      let className = ''
      if (this.$refs.stationTableRef.selection.includes(row)) {
        className = 'is-select'
      }
      return className
    },
    /** 获取电站列表 */
    getStationList () {
      this.loading = true
      this.tableData = []
      GetStringAndEnergyStorageStationsList().then(response => {
        this.loading = false
        this.tableData = response.data || []
        this.tableData.splice(0, 0)
      }).catch(() => {
        this.loading = false
      })
    },
    /** 表格选择变化 */
    handleTableSelectChange (selection) {
      if (selection.length) {
        if (this.queryChartDataTimer) {
          clearTimeout(this.queryChartDataTimer)
        }
        this.queryChartDataTimer = setTimeout(() => {
          this.getChartData()
        }, 1000)
      } else {
        this.chart.data = []
      }
    },
    /** 清除选择的电站 */
    handleClearTableSelect () {
      this.$refs.stationTableRef.clearSelection()
      // this.selected = []
      // this.selectedColor = []
      // this.color = ['#889DCE', '#97CF85', '#E58067', '#F7D96C', '#006976']
      // this.tableData.forEach(o => {
      //   o.color = ''
      // })
    },
    /** 时间类型改变 */
    activeChange (active, format, chartFormat) {
      this.active = active
      this.format = format
      this.chartFormat = chartFormat
      this.getChartData()
    },
    /** 设置查询图表数据参数 */
    setQueryChartDataParam () {
      let st, et
      this.chart.unit = 'kWh'
      this.chart.setting.type = 'histogram'
      if (this.active === 'day') {
        st = this.$parseTime(this.selectTime, this.format) + ' 00:00:00'
        et = this.$parseTime(this.selectTime, this.format) + ' 23:59:59'
        this.chart.unit = 'kW'
        this.chart.setting.type = 'line'
      } else if (this.active === 'month') {
        st = this.$parseTime(this.selectTime, this.format) + '-01 00:00:00'
        et = this.$parseTime(this.selectTime, this.format) +
          `-${this.$gmt(this.selectTime)} 23:59:59`
      } else if (this.active === 'year') {
        st = this.$parseTime(this.selectTime, this.format) + '-01-01 00:00:00'
        et = this.$parseTime(this.selectTime, this.format) + '-12-31 23:59:59'
      } else if (this.active === 'total') {
        st = '2010-01-01'
        et = '2010-01-01'
      }
      const result = {
        dateType: this.active,
        starttime: st,
        endtime: et,
        orgs: this.$refs.stationTableRef.selection.map(o => o.id)
      }
      return result
    },
    /** 获取图表数据 */
    getChartData () {
      if (this.$refs.stationTableRef.selection.length) {
        this.chartLoading = true
        const queryParam = this.setQueryChartDataParam()
        StationsCompare(queryParam).then(response => {
          const data = []
          this.chart.columns = ['time']
          response.data.forEach(o => {
            this.chart.columns.push(o.orgname)
            if (o.datas && o.datas.length) {
              o.datas.forEach(v => {
                v.time = this.$parseTime(v.time, this.chartFormat)
                v[o.orgname] = v.val1
                delete v.val1
                data.push(v)
              })
            }
          })
          this.chart.data = combineData(data, 'time')
          this.chart.extend.color = this.selectedColor
          this.chartLoading = false
        }).catch(() => {
          this.chartLoading = false
        })
      }
    },
  }
}
</script>
<style scoped>
.compare-container {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}
/* 左侧配置区域 */
.compare-container .left-config{
  height: 100%;
  grid-column: 1;
  border: solid 1px #175e77;
  background: #1d3666;
  border-radius: 5px;
  position: relative;
}
.compare-container .left-config .top-toolbar{
  width: 100%;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.compare-container .left-config .top-toolbar .button-clear__selection{
  color: #1cc197;
}
.compare-container .left-config .table-container{
  width: 100%;
  height: calc(100% - 40px);
  padding: 0;
  box-sizing: border-box;
}
.compare-container .left-config>>> .el-table__body-wrapper .cell{
  color: #409EFF;
}
.compare-container .left-config>>>.el-table__empty-text{
  color: #1cc197;
}
.compare-container .left-config>>>.has-gutter .cell .is-indeterminate .el-checkbox__inner,
.compare-container .left-config>>>.has-gutter .cell .is-checked .el-checkbox__inner,
.compare-container .left-config>>>.cell .is-checked .el-checkbox__inner{
  background-color: #1cc197;
  border-color: #1cc197;
}
.compare-container .left-config>>>.table-container .is-select td:nth-of-type(2) .cell,
.compare-container .left-config>>>.table-container .is-select td:nth-of-type(3) .cell{
  color: #1cc197;
}

/* 右侧图表区域 */
.compare-container .right-chart{
  height: 100%;
  grid-column: 2;
  border: solid 1px #175e77;
  background: #1d3666;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.compare-container .right-chart .chart-config{
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.compare-container .right-chart .chart-container{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 0;
  box-sizing: border-box;
}
.compare-container .right-chart .chart-container >>>.v-charts-component-loading{
  background-color: rgba(0, 0, 0, 0.7);
}

</style>
